import { render, staticRenderFns } from "./CatalogSearch.vue?vue&type=template&id=5b6b056a&scoped=true&"
import script from "./CatalogSearch.vue?vue&type=script&lang=js&"
export * from "./CatalogSearch.vue?vue&type=script&lang=js&"
import style0 from "./CatalogSearch.vue?vue&type=style&index=0&id=5b6b056a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6b056a",
  null
  
)

export default component.exports